<template>
  <div class="wrapper">
    <div class="container">
      <MainHeader  />

      <div class="body">
        <div class="body_box">
          <!-- Left 메뉴 표시 -->
          <LeftMenu :items="leftMenuItems" />

          <!-- Content 영역 -->
          <keep-alive>
            <router-view />
          </keep-alive>
        </div>
      </div>

      <!-- Footer 영역 -->
      <Footer />
    </div>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import LeftMenu from "@/components/LeftMenu.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    MainHeader,
    LeftMenu,
    Footer,
  },
  data() {
    return {
      leftMenuItems: [], // Left 메뉴 항목 저장
    };
  },
  methods: {
    
  },

  watch: {
    
  },
  mounted() {
    
  },
};
</script>

<style scoped></style>
